import useLazyData from '@/hooks/useLazyData';
import Skeleton from './skeleton';
import ItemLineMain from './item-line';

const ItemLine = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (props.data) {
    return <ItemLineMain skeleton={skeleton} {...props} />;
  }

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <ItemLineMain skeleton={skeleton} {...props} />;
};

export default ItemLine;
